import {Component, OnInit} from '@angular/core';
import * as angular from "angular";
import {StateService} from "@tva/ng-migration/core/services/state/state.service";
import {RootScopeService} from "@tva/ng-migration/core/services/rootscope/rootscope.service";

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss']
})
export class BreadcrumbsComponent implements OnInit {
  breadcrumbs = [];
  abstractProxyProperty;
  displaynameProperty = "data.displayName";


  constructor(private state: StateService, private rootScope: RootScopeService) {
  }

  ngOnInit() {
    if (this.state.state.$current.name !== '') {
      this.updateBreadcrumbsArray();
    }
    this.rootScope.onChangeSuccess(() => {
      this.updateBreadcrumbsArray();
    });
  }

  /**
   * Start with the current state and traverse up the path to build the
   * array of breadcrumbs that can be used in an ng-repeat in the template.
   */
  updateBreadcrumbsArray() {
    var workingState;
    var displayName;
    var breadcrumbs = [];
    var currentState = this.state.state.$current;

    while (currentState && currentState.name !== '') {
      workingState = this.getWorkingState(currentState);
      if (workingState) {
        displayName = this.getDisplayName(workingState);

        if (displayName !== false && !this.stateAlreadyInBreadcrumbs(workingState, breadcrumbs)) {
          breadcrumbs.push({
            displayName: displayName,
            route: workingState.name
          });
        }
      }
      currentState = currentState.parent;
    }
    breadcrumbs.reverse();
    this.breadcrumbs = breadcrumbs;
  }

  /**
   * Get the state to put in the breadcrumbs array, taking into account that if the current state is abstract,
   * we need to either substitute it with the state named in the `scope.abstractProxyProperty` property, or
   * set it to `false` which means this breadcrumb level will be skipped entirely.
   * @param currentState
   * @returns {*}
   */
  getWorkingState(currentState) {
    var proxyStateName;
    var workingState = currentState;
    if (currentState.abstract === true) {
      if (typeof this.abstractProxyProperty !== 'undefined') {
        proxyStateName = this.getObjectValue(this.abstractProxyProperty, currentState);
        if (proxyStateName) {
          workingState = angular.copy(this.state.state.get(proxyStateName));
          if (workingState) {
            workingState.locals = currentState.locals;
          }
        } else {
          workingState = false;
        }
      } else {
        workingState = false;
      }
    }
    return workingState;
  }

  /**
   * Resolve the displayName of the specified state. Take the property specified by the `displayname-property`
   * attribute and look up the corresponding property on the state's config object. The specified string can be interpolated against any resolved
   * properties on the state config object, by using the usual {{ }} syntax.
   * @param currentState
   * @returns {*}
   */
  getDisplayName(currentState) {
    var interpolationContext;
    var propertyReference;
    var displayName;

    if (!this.displaynameProperty) {
      // if the displayname-property attribute was not specified, default to the state's name
      return currentState.name;
    }
    propertyReference = this.getObjectValue(this.displaynameProperty, currentState);

    if (propertyReference === false) {
      return false;
    } else if (typeof propertyReference === 'undefined') {
      return currentState.name;
    } else {
      // use the $interpolate service to handle any bindings in the propertyReference string.
      const list = propertyReference.split('||');
      if (list[1]) {
        return list[0] + currentState.locals.globals.$stateParams[list[1]];
      } else {
        return propertyReference;
      }
    }
  }

  /**
   * Given a string of the type 'object.property.property', traverse the given context (eg the current $state object) and return the
   * value found at that path.
   *
   * @param objectPath
   * @param context
   * @returns {*}
   */
  getObjectValue(objectPath, context) {
    var i;
    var propertyArray = objectPath.split('.');
    var propertyReference = context;

    for (i = 0; i < propertyArray.length; i++) {
      if (angular.isDefined(propertyReference[propertyArray[i]])) {
        propertyReference = propertyReference[propertyArray[i]];
      } else {
        // if the specified property was not found, default to the state's name
        return undefined;
      }
    }
    return propertyReference;
  }

  /**
   * Check whether the current `state` has already appeared in the current breadcrumbs array. This check is necessary
   * when using abstract states that might specify a proxy that is already there in the breadcrumbs.
   * @param state
   * @param breadcrumbs
   * @returns {boolean}
   */
  stateAlreadyInBreadcrumbs(state, breadcrumbs) {
    var i;
    var alreadyUsed = false;
    for (i = 0; i < breadcrumbs.length; i++) {
      if (breadcrumbs[i].route === state.name) {
        alreadyUsed = true;
      }
    }
    return alreadyUsed;
  }

}
